import InputField from "components/Common/InputField"
import ThemeModal from "components/Common/ThemeModal"
import { useCallback } from "react"
import { toast } from "react-toastify"
import { Form, FormFeedback, Label, Button } from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useCreatePettyCashPaymentPurpose, useEditPettyCashPaymentPurpose } from "hooks/usePettyCashMaster"

const PettyCashPaymentPurposeAddEdit = ({ modal, toggleModal, isEdit, editedData }) => {
  const { mutateAsync: createMutation, isPending: createLoading } = useCreatePettyCashPaymentPurpose()
  const { mutateAsync: editMutation, isPending: editLoading } = useEditPettyCashPaymentPurpose()

  const onSubmit = useCallback(
    async (values, { resetForm }) => {
      const payload = { name: values.name.trim(), description: values.description?.trim() || null }
      try {
        const res = await (isEdit ? editMutation({ id: editedData.id, ...payload }) : createMutation(payload))
        toast.success(res?.message ?? `Payment purpose ${isEdit ? "updated" : "created"} successfully.`)
        resetForm()
        toggleModal()
      } catch {
        toast.error("Failed to save payment purpose.")
      }
    },
    [isEdit, editedData, editMutation, createMutation, toggleModal]
  )

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { name: editedData?.name || "", description: editedData?.description || "" },
    validationSchema: Yup.object({ name: Yup.string().trim().required("Name is required") }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit,
  })

  const isSubmitDisabled = editLoading || createLoading

  return (
    <ThemeModal isOpen={modal} toggle={toggleModal} title={isEdit ? "Edit Payment Purpose" : "Add Payment Purpose"}>
      <Form onSubmit={e => { e.preventDefault(); formik.handleSubmit() }}>
        <div className="mb-3">
          <Label htmlFor="name">Name</Label>
          <InputField type="text" name="name" id="name" value={formik.values.name} onChange={formik.handleChange} invalid={formik.touched.name && !!formik.errors.name} />
          {formik.touched.name && formik.errors.name && <FormFeedback type="invalid">{formik.errors.name}</FormFeedback>}
        </div>
        <div className="mb-3">
          <Label htmlFor="description">Description</Label>
          <InputField type="textarea" name="description" id="description" value={formik.values.description} onChange={formik.handleChange} rows={3} />
        </div>
        <div className="text-end">
          <Button color="success" type="submit" disabled={isSubmitDisabled}>
            {isEdit ? "Save Changes" : "Add Purpose"}{isSubmitDisabled ? "..." : ""}
          </Button>
        </div>
      </Form>
    </ThemeModal>
  )
}

export default PettyCashPaymentPurposeAddEdit
